import { useEffect, useRef } from "react";

type PropsType = {
  enabled: boolean;
  interval?: number;
  pollingFunction: () => void | Promise<unknown>;
  onTimeout?: () => void;
  timeoutDuration?: number | null;
};

export const useApiPolling = ({
  enabled,
  interval = 2000,
  pollingFunction,
  onTimeout,
  timeoutDuration = 30000,
}: PropsType) => {
  const startTimeRef = useRef<number>(0);

  useEffect(() => {
    if (!enabled) return;

    startTimeRef.current = Date.now();

    const timerId = setInterval(() => {
      // timeoutDuration が null の場合は無制限に動作
      if (timeoutDuration !== null) {
        const elapsedTime = Date.now() - startTimeRef.current;

        if (elapsedTime >= timeoutDuration) {
          onTimeout?.();
          return;
        }
      }

      void pollingFunction();
    }, interval);

    return () => clearInterval(timerId);
  }, [enabled, interval, pollingFunction, onTimeout, timeoutDuration]);
};
